module.exports = __webpack_public_path__ + "media/images/grid-icon-9b38a9bc2545b484014d7c10e277e8bc.svg";